import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { SaveUserStateToServerHelper } from "../Helper";
import {
  nextExam,
  setIsTypingStarted,
  setRemainingTime,
  setStartTime,
} from "./../../actions/assessment";

export class TypingPracticeTest extends Component {
  state = {
    practice_answer:
      this.props.assessment.exams[this.props.assessment.exam_index]
        .practice_answer,
  };

  is_typing_started = () => {
    if (!this.props.is_typing_started) {
      this.props.setIsTypingStarted(true);
      this.props.setStartTime();
    }
  };

  handleChange = (event) => {
    this.setState({ practice_answer: event.target.value });
    let exams = this.props.assessment.exams;
    exams[this.props.assessment.exam_index].practice_answer =
      event.target.value;
  };

  componentDidUpdate(prevProps, prevState) {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  render() {
    return (
      <>
        <div className="main container-fluid h-100">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="container">
                <TransitionGroup className="card-container">
                  <CSSTransition
                    key={this.props.question.id}
                    timeout={500}
                    classNames="fade"
                  >
                    <div className="test">
                      <div className="question typing">
                        <h4>
                          <span>
                            The timer will begin when you type your first
                            character. Your keystrokes will not be captured for
                            this practice test. Enter only one space following a
                            sentence.
                          </span>
                        </h4>

                        <div className="row">
                          <div className="col-6">
                            <h6 className="mb-3">Text to be typed :</h6>

                            <div className="card q-typing mb-2 h-100">
                              <div
                                className="card-body"
                                style={{ userSelect: null }}
                              >
                                <p>
                                  Teamwork plays a crucial role in the success
                                  of any workplace. Whether it's a small
                                  business, a large corporation, or even a
                                  school project, collaborating effectively with
                                  colleagues can lead to outstanding results. In
                                  today's fast-paced work environment, the
                                  ability to work well with others is highly
                                  valued by employers.
                                </p>

                                <p>
                                  One of the primary benefits of teamwork is the
                                  pooling of diverse skills and expertise. When
                                  individuals with different backgrounds and
                                  strengths come together, they bring a variety
                                  of ideas and perspectives to the table. This
                                  diversity can lead to innovative
                                  problem-solving and creative solutions. For
                                  example, in a marketing team, one member might
                                  excel at graphic design, while another might
                                  have strong analytical skills. By combining
                                  their talents, they can create compelling
                                  campaigns that resonate with their target
                                  audience.
                                </p>

                                <p>
                                  Moreover, teamwork fosters a sense of
                                  camaraderie and support among team members.
                                  When colleagues collaborate and support each
                                  other, it creates a positive work environment
                                  where individuals feel valued and motivated.
                                  This, in turn, leads to increased job
                                  satisfaction and productivity. When employees
                                  feel connected to their team, they are more
                                  likely to go the extra mile to achieve shared
                                  goals.
                                </p>

                                <p>
                                  In addition, teamwork enhances communication
                                  skills. Effective communication is essential
                                  for coordinating tasks, sharing information,
                                  and resolving conflicts. When team members
                                  actively listen, respect each other's
                                  opinions, and provide constructive feedback,
                                  it improves overall communication within the
                                  workplace. Clear and open lines of
                                  communication prevent misunderstandings,
                                  reduce errors, and promote a harmonious work
                                  atmosphere.
                                </p>

                                <p>
                                  However, successful teamwork requires certain
                                  key elements. First and foremost, team members
                                  must have a shared understanding of their
                                  goals and objectives. This clarity ensures
                                  that everyone is working towards the same
                                  purpose. Additionally, each team member should
                                  be aware of their specific roles and
                                  responsibilities to avoid duplication of
                                  effort or confusion.
                                </p>

                                <p>
                                  To foster effective teamwork, it is important
                                  to promote collaboration and provide
                                  opportunities for team building activities.
                                  Encouraging open dialogue, organizing
                                  team-building exercises, and recognizing and
                                  celebrating team achievements can strengthen
                                  bonds among team members.
                                </p>

                                <p>
                                  In conclusion, teamwork is an essential
                                  ingredient for workplace success. By
                                  harnessing the power of diverse skills,
                                  fostering a supportive environment, and
                                  promoting effective communication, teams can
                                  achieve remarkable outcomes. Cultivating
                                  teamwork skills from an early age prepares
                                  individuals for future work environments and
                                  equips them with the ability to thrive in
                                  collaborative settings.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <h6 className="mb-3">Type Text here :</h6>

                            <div className="card q-typing mb-2 h-100">
                              <div className="card-body p-2">
                                <textarea
                                  rows="9"
                                  placeholder="Type here..."
                                  autoFocus
                                  onKeyDown={this.is_typing_started}
                                  value={this.state.practice_answer}
                                  onChange={this.handleChange}
                                  ref={(ref) => ref && ref.focus()}
                                  onFocus={(e) =>
                                    e.currentTarget.setSelectionRange(
                                      e.currentTarget.value.length,
                                      e.currentTarget.value.length
                                    )
                                  }
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
  is_typing_started: state.assessment.is_typing_started,
});

const mapDispatchToProps = (dispatch) => ({
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  setIsTypingStarted: (value) => dispatch(setIsTypingStarted(value)),
  setStartTime: () => dispatch(setStartTime(Date.now())),
});

export default connect(mapStateToProps, mapDispatchToProps)(TypingPracticeTest);
